// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeRedblue = {
  redbluePlatformDataContractInvalid:
    "RedBlue プラットフォームデータ契約が無効です ({field_name}: {reason})",
  redblueBusinessEventInboxRetryLater:
    "RedBlue ビジネスイベントは処理中です。後で元のイベントを再試行してください",
  redblueBusinessEventUnexpectedRetryableFailure:
    "RedBlue ビジネスイベントで一時的な依存障害が発生したため、元のイベントとして再試行します",
} as const;
